import { render, staticRenderFns } from "./tableLogImport.vue?vue&type=template&id=53262741"
import script from "./tableLogImport.vue?vue&type=script&lang=js"
export * from "./tableLogImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports